import { useCallback, useSyncExternalStore, type ReactNode } from "react";

import {
  bookSpoilersOpen,
  onBookSpoilersChange,
  setBookSpoilersOpen,
} from "../data/open-book-spoilers";

interface BookSpoilersProps {
  bookId: string;
  bookTitle: string;
  children: ReactNode;
}

/** A book's spoilers, closed until opened. Opening one opens that book's everywhere, for good. */
export function BookSpoilers({ bookId, bookTitle, children }: BookSpoilersProps) {
  const read = useCallback(() => bookSpoilersOpen(bookId), [bookId]);
  const open = useSyncExternalStore(onBookSpoilersChange, read);
  return (
    <div className="timeline-scene-spoilers">
      <button
        type="button"
        className="timeline-scene-spoilers__toggle"
        aria-expanded={open}
        onClick={() => {
          setBookSpoilersOpen(bookId, !open);
        }}
      >
        <span aria-hidden="true">{open ? "▾" : "▸"}</span> Spoilers from {bookTitle}
      </button>
      {open ? children : null}
    </div>
  );
}
